import { Id } from "@dhx/ts-common/types";
import { Diagram, ItemConfig, DiagramEvents } from "@dhx/ts-diagram";
import { ISelectionBox } from "./types";

export class BlockSelection {
	private _diagram: Diagram;
	private _diagramSize: any;
	private _isOrgType: boolean;

	constructor(diagram: Diagram) {
		this._diagram = diagram;
		this._isOrgType = ["org", "mindmap"].includes(this._diagram.config.type);
		this._diagram.events.on(DiagramEvents.beforeRender, size => (this._diagramSize = size));
	}
	updateSelection(selection: ISelectionBox, mode: "add" | "remove" | "create" = "create") {
		const leftLim = selection.start.x < selection.end.x ? selection.start.x : selection.end.x;
		const rightLim = selection.end.x > selection.start.x ? selection.end.x : selection.start.x;
		const topLim = selection.start.y < selection.end.y ? selection.start.y : selection.end.y;
		const botLim = selection.end.y > selection.start.y ? selection.end.y : selection.start.y;

		this._diagram.data.mapVisible(item => {
			if (item.$group || (this._isOrgType && item.$item.getBaseType() === "line")) {
				return;
			}
			const rect = item.$item.getBox();
			if (
				rect.left >= leftLim &&
				rect.right <= rightLim &&
				rect.top >= topLim &&
				rect.bottom <= botLim
			) {
				this._diagram.data.update(
					item.id,
					{
						$blockSelected: mode === "add" || mode === "create",
					},
					true
				);
			} else if (mode === "create") {
				this._diagram.data.update(item.id, { $blockSelected: false }, true);
			}
			this._diagram.data.update(item.id, { $selected: false }, true);
		});
	}
	clearSelection() {
		this._diagram.data
			.map(config => config)
			.forEach(i => {
				this._diagram.data.update(i.id, { $blockSelected: false }, true);
			});
	}
	add(id: Id) {
		this._diagram.data.update(id, { $blockSelected: true }, true);
	}
	remove(id: Id) {
		this._diagram.data.update(id, { $blockSelected: false }, true);
	}
	getSelected(): Id[] {
		return this._diagram.data
			.map((config: ItemConfig) => {
				if (config.$blockSelected) {
					return config.id;
				}
				return false;
			})
			.filter(id => id);
	}
	getCurrentCoordinates(event: MouseEvent, container: HTMLElement) {
		const diagramRect = container.getBoundingClientRect();
		const diagramMargins = this._diagram.config.margin;
		const size = this._diagramSize || { left: -diagramMargins.x, top: -diagramMargins.y };
		const scale = this._diagram.config.scale;
		const scrolls = {
			x: container.scrollLeft,
			y: container.scrollTop,
		};

		return {
			x:
				(event.clientX - diagramRect.left + scrolls.x) / scale -
				diagramMargins.x +
				(size.left + diagramMargins.x),
			y:
				(event.clientY - diagramRect.top + scrolls.y) / scale -
				diagramMargins.y +
				(size.top + diagramMargins.y),
			$rx: event.clientX - diagramRect.left + scrolls.x,
			$ry: event.clientY - diagramRect.top + scrolls.y,
		};
	}
}
